import { Action } from 'redux';
import { Contact } from 'model/contact';

// Error actions
export const CONTACT_ERROR = 'contact/error';
export interface ContactErrorAction extends Action<typeof CONTACT_ERROR> {
    payload: { error: string };
}

export const CONTACT_CLEAR_ERROR = 'contact/clear_error';
export type ContactClearErrorAction = Action<typeof CONTACT_CLEAR_ERROR>;

// Fetch actions
export const CONTACT_FETCH_START = 'contact/fetch_start';
export type ContactFetchStartAction = Action<typeof CONTACT_FETCH_START>;

export const CONTACT_FETCH_SUCCESS = 'contact/fetch_success';
export interface ContactFetchSuccessAction extends Action<typeof CONTACT_FETCH_SUCCESS> {
    payload: { contacts: Array<Contact> };
}

// Save actions (create or update)
export const CONTACT_SAVE_START = 'contact/save_start';
export type ContactSaveStartAction = Action<typeof CONTACT_SAVE_START>;

export const CONTACT_SAVE_SUCCESS = 'contact/save_success';
export interface ContactSaveSuccessAction extends Action<typeof CONTACT_SAVE_SUCCESS> {
    payload: { contact: Contact };
}

// Delete actions
export const CONTACT_DELETE_START = 'contact/delete_start';
export type ContactDeleteStartAction = Action<typeof CONTACT_DELETE_START>;

export const CONTACT_DELETE_SUCCESS = 'contact/delete_success';
export interface ContactDeleteSuccessAction extends Action<typeof CONTACT_DELETE_SUCCESS> {
    payload: { contactId: number };
}

// Union type of all contact actions
export type ContactAction =
    | ContactErrorAction
    | ContactClearErrorAction
    | ContactFetchStartAction
    | ContactFetchSuccessAction
    | ContactSaveStartAction
    | ContactSaveSuccessAction
    | ContactDeleteStartAction
    | ContactDeleteSuccessAction;
